const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');

const OrderCountView = require('app/product/stat/OrderCountView');
const NetSaleView = require('app/product/stat/NetSaleView');
const AverageSupplierPriceView = require('app/product/stat/AverageSupplierPriceView');
const AveragePriceView = require('app/product/stat/AveragePriceView');
const AverageMarginView = require('app/product/stat/AverageMarginView');
const RestaurantCARankView = require('app/product/stat/RestaurantCARankView');

class StatTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'product': {'id':null,'name':null},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmitForm = this.onSubmitForm.bind(this);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.product = this.settings.product;
        if(!this.product.id){
            window.notify("Missing valid product","error");
        }

        this.initialize();
    }

    initialize() {
        var self = this;

        this.buildTab();
    }
    onDOMReady(){
    }

    buildTab(){

        this.$resultContainer = $('<div/>');

        this.$content = $('<div/>')
        .append(this.buildForm())
        .append(this.$resultContainer);


        this.$container
        .html('')
        .append(this.$content);

        this.$form.trigger('submit');
    }


    buildForm(){
        let begin = moment().startOf('year').format('YYYY-MM-DD');
        let end = moment().endOf('year').format('YYYY-MM-DD');

        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-info')
        .append(
            $('<i/>')
            .addClass('far fa-search')
        );

        this.$form = $('<form/>')
        .addClass('product-stat-form')
        .addClass('white-box')
        .on("submit",this.onSubmitForm);

        let $row = $('<div/>')
        .addClass('row');

        this.$inputFrom = $('<input/>')
        .attr('id','from')
        .attr('type','date')
        .attr('name','from')
        .addClass('form-control')
        .attr('required','required')
        .val(begin);

        $row.append(
            $('<div/>')
            .addClass('col-5 p-2')
            .append(
                $('<div/>')
                .append(
                    $('<div/>')
                    .addClass('input-group')
                    .append(
                        $('<div/>')
                        .addClass('input-group-text')
                        .append(window.translate('from'))
                    )
                    .append(this.$inputFrom)
                )
            )
        );

        this.$inputTo = $('<input/>')
        .attr('id','to')
        .attr('type','date')
        .attr('name','to')
        .addClass('form-control')
        .attr('required','required')
        .val(end);

        $row.append(
            $('<div/>')
            .addClass('col-5 p-2')
            .append(
                $('<div/>')
                .append(
                    $('<div/>')
                    .addClass('input-group')
                    .append(
                        $('<div/>')
                        .addClass('input-group-text')
                        .append(window.translate('to'))
                    )
                    .append(this.$inputTo)
                )
            )
        );

        $row.append(
            $('<div/>')
            .addClass('col-2 p-2 mt-auto')
            .append(this.$btnSubmit)
        );

        this.$form
        .addClass('d-flex justify-content-center')
        .append($row);

        return this.$form;
    }

    onSubmitForm(event){
        event.preventDefault();
        event.stopPropagation();
        
        this.loadData();
    }

    loadData(){
        var self = this;

        this.$resultContainer
        .html('')
        .append(window.App.generateLoader())

        let queries = [
            this.buildProductStatisticQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildResult(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildProductStatisticQuery(){
        var self = this;

        let parameters = {
            'product': this.product.id,
            'from': this.$inputFrom.val(),
            'to': this.$inputTo.val(),
        };

        let fields = [
            'product { id reference quantity unit }',
            'netSaleByMonth { x y }',
            'ordersCountByMonth { x y }',
            'averageSupplierPriceByMonth { x y }',
            'averagePriceByMonth { x y }',
            'averageMarginByMonth { x y y2 }',
            'netSaleRestaurantRank { restaurant { id name } netSale }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplierProductStatistic',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }

    buildResult(data){

        this.supplierProductStatistic = data.supplierProductStatistic;

        this.product = this.supplierProductStatistic.product;
        this.netSaleByMonth = this.supplierProductStatistic.netSaleByMonth;
        this.ordersCountByMonth = this.supplierProductStatistic.ordersCountByMonth;
        this.averageSupplierPriceByMonth = this.supplierProductStatistic.averageSupplierPriceByMonth;
        this.averagePriceByMonth = this.supplierProductStatistic.averagePriceByMonth;
        this.averageMarginByMonth = this.supplierProductStatistic.averageMarginByMonth;
        this.netSaleRestaurantRank = this.supplierProductStatistic.netSaleRestaurantRank;

        this.$netSaleByMonthContainer = $('<div/>')
        .addClass('white-box');
        this.$ordersCountByMonthContainer = $('<div/>')
        .addClass('white-box');
        this.$averageSupplierPriceByMonthContainer = $('<div/>')
        .addClass('white-box');
        this.$averagePriceByMonthContainer = $('<div/>')
        .addClass('white-box');
        this.$averageMarginByMonthContainer = $('<div/>')
        .addClass('white-box');
        this.$netSaleRestaurantRankContainer = $('<div/>')
        .addClass('white-box');

        this.$resultContainer
        .html('')
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.$netSaleByMonthContainer)
            )
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.$ordersCountByMonthContainer)
            )
        )
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.$averageSupplierPriceByMonthContainer)
            )
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.$averagePriceByMonthContainer)
            )
        )
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.$averageMarginByMonthContainer)
            )
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.$netSaleRestaurantRankContainer)
            )
        );
        
        this.orderCountView = new OrderCountView({
            '$container': this.$ordersCountByMonthContainer,
            'data': this.ordersCountByMonth,
            'product': this.product,
        });

        this.netSaleView = new NetSaleView({
            '$container': this.$netSaleByMonthContainer,
            'data': this.netSaleByMonth,
            'product': this.product,
        });

        this.averageSupplierPriceView = new AverageSupplierPriceView({
            '$container': this.$averageSupplierPriceByMonthContainer,
            'data': this.averageSupplierPriceByMonth,
            'product': this.product,

        });

        this.averagePriceView = new AveragePriceView({
            '$container': this.$averagePriceByMonthContainer,
            'data': this.averagePriceByMonth,
            'product': this.product,
        });
        

        this.averageMarginView = new AverageMarginView({
            '$container': this.$averageMarginByMonthContainer,
            'data': this.averageMarginByMonth,
            'product': this.product,

        });

        this.restaurantCARankView = new RestaurantCARankView({
            '$container': this.$netSaleRestaurantRankContainer,
            'data': this.netSaleRestaurantRank,
            'product': this.product,
        });
    }


}

module.exports = StatTab;

